export default __webpack_public_path__ + "static/assets/med_x_inhaler_mask.c53915d0.png";